// Validation des identifiants de facturation : SIRET/SIREN (Luhn) et n° de TVA
// intracommunautaire (clé FR mod 97 + Luhn du SIREN ; contrôle souple hors-FR).
// Champs OPTIONNELS : une valeur vide est toujours valide.
//
// NB: jumeau de src/utils/businessIdValidation.js (le conteneur server/ ne peut
// pas importer depuis src/). Garder les deux fichiers synchronisés.

function normalizeSiret(value) {
    if (value === null || value === undefined) return '';
    return String(value).replace(/\s/g, '');
}

function normalizeVatNumber(value) {
    if (value === null || value === undefined) return '';
    return String(value).replace(/\s/g, '').toUpperCase();
}

// Algorithme de Luhn sur une chaîne de chiffres.
function luhnValid(digits) {
    if (!/^\d+$/.test(digits)) return false;
    let sum = 0;
    let double = false;
    for (let i = digits.length - 1; i >= 0; i--) {
        let d = digits.charCodeAt(i) - 48;
        if (double) {
            d *= 2;
            if (d > 9) d -= 9;
        }
        sum += d;
        double = !double;
    }
    return sum % 10 === 0;
}

function validateSiret(value) {
    const v = normalizeSiret(value);
    if (v === '') return { valid: true, error: null };
    if (!/^\d+$/.test(v) || (v.length !== 9 && v.length !== 14)) {
        return { valid: false, error: 'SIRET (14 chiffres) ou SIREN (9 chiffres) invalide' };
    }
    if (!luhnValid(v)) {
        return { valid: false, error: 'Numéro SIRET/SIREN invalide (clé de contrôle incorrecte)' };
    }
    return { valid: true, error: null };
}

// Clé de contrôle de la TVA française : (12 + 3 * (SIREN mod 97)) mod 97.
function frenchVatKey(siren) {
    return (12 + 3 * (parseInt(siren, 10) % 97)) % 97;
}

function validateVatNumber(value) {
    const v = normalizeVatNumber(value);
    if (v === '') return { valid: true, error: null };
    if (!/^[A-Z]{2}/.test(v)) {
        return { valid: false, error: 'Le n° de TVA doit commencer par un code pays (ex. FR, BE)' };
    }
    const country = v.slice(0, 2);
    const rest = v.slice(2);

    if (country === 'FR') {
        // FR + clé (2 caractères) + SIREN (9 chiffres)
        if (!/^[0-9A-Z]{2}\d{9}$/.test(rest)) {
            return { valid: false, error: 'N° de TVA français invalide (format FR + clé + 9 chiffres)' };
        }
        const key = rest.slice(0, 2);
        const siren = rest.slice(2);
        if (!luhnValid(siren)) {
            return { valid: false, error: 'N° de TVA français invalide (SIREN incorrect)' };
        }
        // Si la clé est numérique, vérifier la clé mod 97 (double vérification).
        if (/^\d{2}$/.test(key)) {
            const expected = String(frenchVatKey(siren)).padStart(2, '0');
            if (key !== expected) {
                return { valid: false, error: 'N° de TVA français invalide (clé de contrôle incorrecte)' };
            }
        }
        return { valid: true, error: null };
    }

    // Autres pays UE : contrôle souple (2 à 12 caractères alphanumériques).
    if (!/^[0-9A-Z]{2,12}$/.test(rest)) {
        return { valid: false, error: 'N° de TVA intracommunautaire invalide' };
    }
    return { valid: true, error: null };
}

module.exports = {
    normalizeSiret,
    normalizeVatNumber,
    luhnValid,
    validateSiret,
    validateVatNumber,
    frenchVatKey,
};
